import { FC } from "react";
import { Clipboard } from "lucide-react";

import { SiteItem } from "@vviinn/user-managment-client-ts";

import { NamedRow } from "../../../components/GeneralUI/NamedRow/NamedRow";

import { credentialsKeys, credentialsTitles } from "./constants";
import { Credentials, HandleRequest } from "./types";
import { CredentialsAcceptableRow } from "./CredentialsAcceptableRow";
import { useNotifications } from "../../../app/useNotifications";
import { LARGE_ICON_SIZE_STYLES } from "../../../ui/styles";
import { SubSectionWithStyles } from "../../../ui/layout";

type CredentialsEditBlockProps = HandleRequest & {
  siteDetails?: SiteItem;
};

export const CredentialsEditBlock: FC<
  React.PropsWithChildren<CredentialsEditBlockProps>
> = ({ siteDetails, handleRequests }) => {
  const { notify } = useNotifications();
  const onCopyClick = async (key: Credentials) => {
    if (!siteDetails) return;
    const data =
      key === "password" || key === "username"
        ? siteDetails.credentials.api[key]
        : siteDetails.credentials.jwt[key];
    try {
      await navigator.clipboard.writeText(data);
      notify("Success", `${credentialsTitles[key]} has been copied`);
    } catch (error) {
      let errorMessage = "Unknown Error";
      if (error instanceof Error) {
        errorMessage = error.message;
      }
      notify("Error", errorMessage);
    }
  };

  return (
    <SubSectionWithStyles title="API Credentials">
      {credentialsKeys.map((key, index) => (
        <NamedRow
          key={index}
          title={credentialsTitles[key]}
          editPermissions={
            key === "readOnly"
              ? "site:readonly_token:view"
              : "site:credentials:view"
          }
          content="************"
          onClick={() => onCopyClick(key)}
          icon={
            <Clipboard
              className={`justify-self-end text-stone-400 underline dark:text-stone-300 ${LARGE_ICON_SIZE_STYLES}`}
            />
          }
        ></NamedRow>
      ))}
      <CredentialsAcceptableRow handleRequests={handleRequests} />
    </SubSectionWithStyles>
  );
};
